import * as tslib_1 from "tslib";
import 'core-js/es7/symbol';
import * as ko from 'knockout';
import { Router } from './router';
import { isThenable, castLifecycleObjectMiddlewareToGenerator, sequence } from './utils';
var Context /* implements IContext, use Context & IContext */ = /** @class */ (function () {
    function Context(router, $parent, path, _with) {
        if (_with === void 0) { _with = {}; }
        this.router = router;
        this.$parent = $parent;
        this.path = path;
        this._queue = [];
        this._beforeNavigateCallbacks = [];
        this._appMiddlewareDownstream = [];
        this._routeMiddlewareDownstream = [];
        var route = router.resolveRoute(path);
        var _a = route.parse(path), params = _a.params, pathname = _a.pathname, childPath = _a.childPath;
        Object.assign(this, {
            params: params,
            pathname: pathname,
            route: route
        }, _with);
        if ($parent) {
            $parent.$child = this;
        }
        if (childPath) {
            // tslint:disable-next-line no-unused-expression
            new Router(childPath, this).ctx;
        }
    }
    Context.prototype.addBeforeNavigateCallback = function (cb) {
        this._beforeNavigateCallbacks.unshift(cb);
    };
    Object.defineProperty(Context.prototype, "base", {
        get: function () {
            return this.router.isRoot
                ? Router.base
                : this.$parent.base + this.$parent.pathname;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "canonicalPath", {
        // full path w/o base
        get: function () {
            return this.base.replace(new RegExp(this.$root.base, 'i'), '') + this.pathname;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "element", {
        get: function () {
            return this._redirect ? undefined : document.getElementsByClassName('router-view')[this.$parents.length];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "$root", {
        get: function () {
            var ctx = this;
            while (ctx) {
                if (ctx.$parent) {
                    ctx = ctx.$parent;
                }
                else {
                    return ctx;
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "$parents", {
        get: function () {
            var parents = [];
            var parent = this.$parent;
            while (parent) {
                parents.push(parent);
                parent = parent.$parent;
            }
            return parents;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "$children", {
        get: function () {
            var children = [];
            var child = this.$child;
            while (child) {
                children.push(child);
                child = child.$child;
            }
            return children;
        },
        enumerable: true,
        configurable: true
    });
    Context.prototype.queue = function (promise) {
        this._queue.push(promise);
    };
    Context.prototype.redirect = function (path, args) {
        if (args === void 0) { args = {}; }
        this._redirect = path;
        this._redirectArgs = Object.assign({}, args, { push: false });
    };
    Context.prototype.runBeforeNavigateCallbacks = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ctx, callbacks, success;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ctx = this;
                        callbacks = [];
                        while (ctx) {
                            callbacks = tslib_1.__spread(ctx._beforeNavigateCallbacks, callbacks);
                            ctx = ctx.$child;
                        }
                        return [4 /*yield*/, sequence(callbacks)];
                    case 1:
                        success = (_a.sent()).success;
                        return [2 /*return*/, success];
                }
            });
        });
    };
    Context.prototype.render = function () {
        var ctx = this;
        while (ctx) {
            if (typeof ctx._redirect === 'undefined') {
                ctx.router.component(ctx.route.component);
            }
            ctx = ctx.$child;
        }
        ko.tasks.runEarly();
    };
    Context.prototype.runBeforeRender = function (flush) {
        if (flush === void 0) { flush = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var appMiddlewareDownstream, routeMiddlewareDownstream, numAppMiddlewareRanPreRedirect, numRouteMiddlewareRanPreRedirect;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        appMiddlewareDownstream = Context.runMiddleware(Router.middleware, this);
                        routeMiddlewareDownstream = Context.runMiddleware(this.route.middleware, this);
                        return [4 /*yield*/, sequence(appMiddlewareDownstream)];
                    case 1:
                        numAppMiddlewareRanPreRedirect = (_a.sent()).count;
                        return [4 /*yield*/, sequence(routeMiddlewareDownstream)];
                    case 2:
                        numRouteMiddlewareRanPreRedirect = (_a.sent()).count;
                        this._appMiddlewareDownstream = appMiddlewareDownstream.slice(0, numAppMiddlewareRanPreRedirect);
                        this._routeMiddlewareDownstream = routeMiddlewareDownstream.slice(0, numRouteMiddlewareRanPreRedirect);
                        if (!(this.$child && typeof this._redirect === 'undefined')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.$child.runBeforeRender(false)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        if (!flush) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.flushQueue()];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    Context.prototype.runAfterRender = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, sequence(tslib_1.__spread(this._appMiddlewareDownstream, this._routeMiddlewareDownstream))];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.flushQueue()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Context.prototype.runBeforeDispose = function (flush) {
        if (flush === void 0) { flush = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.$child && typeof this._redirect === 'undefined')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$child.runBeforeDispose(false)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, sequence(tslib_1.__spread(this._routeMiddlewareDownstream, this._appMiddlewareDownstream))];
                    case 3:
                        _a.sent();
                        if (!flush) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.flushQueue()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Context.prototype.runAfterDispose = function (flush) {
        if (flush === void 0) { flush = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.$child && typeof this._redirect === 'undefined')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$child.runAfterDispose(false)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, sequence(tslib_1.__spread(this._routeMiddlewareDownstream, this._appMiddlewareDownstream))];
                    case 3:
                        _a.sent();
                        if (!flush) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.flushQueue()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Context.prototype.flushQueue = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var thisQueue, childQueues;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        thisQueue = Promise.all(this._queue).then(function () {
                            _this._queue = [];
                        });
                        childQueues = this.$children.map(function (c) { return c.flushQueue(); });
                        return [4 /*yield*/, Promise.all(tslib_1.__spread([thisQueue], childQueues))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Context.runMiddleware = function (middleware, ctx) {
        var _this = this;
        return middleware.map(function (fn) {
            var runner = castLifecycleObjectMiddlewareToGenerator(fn)(ctx);
            var beforeRender = true;
            return function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var ret;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            ret = runner.next();
                            if (!isThenable(ret)) return [3 /*break*/, 2];
                            return [4 /*yield*/, ret];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 4];
                        case 2:
                            if (!isThenable(ret.value)) return [3 /*break*/, 4];
                            return [4 /*yield*/, ret.value];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            if (beforeRender) {
                                // this should only block the sequence for the first call,
                                // and allow cleanup after the redirect
                                beforeRender = false;
                                return [2 /*return*/, typeof ctx._redirect === 'undefined'];
                            }
                            else {
                                return [2 /*return*/, true];
                            }
                            return [2 /*return*/];
                    }
                });
            }); };
        });
    };
    return Context;
}());
export { Context };
//# sourceMappingURL=context.js.map